<template>
  <div class="previewDetail">
    <el-form class="previewDetailForm" label-width="100px" >
      <el-form-item label="任务名称">
        <div>
          {{formData.name}}
        </div>
      </el-form-item>
      <el-form-item label="选择用户">
        <!-- 如果是全部用户，则显示“全部联系人” 
        按条件发送，则显示按条件发送。鼠标上移显示条件字段选项。如没有值则显示为 -->
        <div v-if="formData.sendType==1">
          <el-popover
            placement="bottom"
            width="300"
            height="300"
            trigger="click"
            popper-class="my-popover my-popover-term"
          >
            <filter-Item
              :tagGroupArr="filterGroupArr"
            ></filter-Item>
              <span  class="reference"
              size="mini"
              slot="reference" @click="filterConditions()">
              按条件发送
            </span>
          </el-popover>
        </div>
        <div v-else-if="formData.sendType==2">
          全部联系人
        </div>
        <div v-else-if="formData.sendType==3">按指定联系人发送</div>
      </el-form-item>
      <el-form-item label="目标用户数">
        <div>
         {{formData.submitTotal!=undefined&&formData.submitTotal!=null?formData.submitTotal:'---'}}
        </div>
      </el-form-item>
       <el-form-item label="邮件标题">
        <div>
          {{formData.title}}
        </div>
      </el-form-item>
      <el-form-item label="回复邮箱">
        <div>
          {{formData.replyEmail}}
        </div>
      </el-form-item>
      <el-form-item label="发送时间">
        <!-- <div v-if="formData.submitTotal!=undefined&&formData.submitTotal!=null"> -->
        <div v-if="formData.sendModel==1">
          {{formData.submitTotal!=undefined&&formData.submitTotal!=null?'立即发送':'---'}}
        </div>
        <div v-else>
          <div>
            <div class="definiteTimediv">
              <span class="definiteTime"><i class="iconfont icon-icon-dingshi"></i>定时发送</span>
              <span v-if="formData.scheduleSendTimezone">{{localtimeBlur()}}</span>
              <span v-else>{{(formData.realSendTime!=undefined&&formData.realSendTime!=null?formData.realSendTime:formData.scheduleSendTime) | format('YYYY-MM-DD HH:mm')}}</span>
            </div>
            <div class="scheduleSendTimezoneStr" >
              <div>
                <span class="label">已选时区:</span>
                <span v-if="(formData.realSendTime!=undefined&&formData.realSendTime!=null)||(formData.scheduleSendTimezoneTime!=undefined&&formData.scheduleSendTimezoneTime!=null)">{{ formData.scheduleSendTimezoneStr||'（UTC+08:00）北京、香港、台湾' }}</span>
                <span v-else>---</span>
              </div>
              <div>
                <span class="label">当地时间:</span>
                <span v-if="formData.scheduleSendTimezone">{{(formData.scheduleSendTimezoneTime!=undefined&&formData.scheduleSendTimezoneTime!=null?formData.scheduleSendTimezoneTime:formData.scheduleSendTimezoneTime) | format('YYYY-MM-DD HH:mm')}}</span>
                <span v-else>{{(formData.realSendTime!=undefined&&formData.realSendTime!=null?formData.realSendTime:formData.scheduleSendTime) | format('YYYY-MM-DD HH:mm')}}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- </div>
        <div v-else>---</div> -->
      </el-form-item>
      <el-form-item label="邮件签名"  class="signItem"  label-position="top">
        <div v-if="formData.signatureId==''||formData.signatureId==null||formData.signatureId==0">
          不显示签名
        </div>
        <div v-else class="signatureDiv" >
          <div v-html="signature"></div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import FilterItem from "./filterItem.vue";
import { dayjsFormat } from '@/utils/common.js'
export default {
  props:{
    formData:{
      type:Object,
      default:{}
    },
    signature:{
      type:String,
      default:''
    },
    filterGroupArr:{
      type:Array,
      default:[]
    }
  },
  components: {
    FilterItem,
  },
  data(){
    return{
      // filterGroupArr: [],
    }
  },
  methods:{
    filterConditions(){
      console.log(3414)
    },
    localtimeBlur(){
      let dayObj= dayjsFormat(this.formData.scheduleSendTimezoneTime,this.formData.scheduleSendTimezone)
      return dayObj.timeresY
    },
  },
  mounted(){
    console.log(this.formData)
  }
}
</script>
<style lang="scss" scoped>
.previewDetail{
  margin-top: -8px;
 ::v-deep .previewDetailForm{
    .el-form-item__label{
      color: #4f5d78ff;
      font-size: 12px;
      font-face: SourceHanSansCN;
      font-weight: 400;
    }
    .el-form-item__content{
      font-size: 12px;
    }
    .el-radio__label{
      font-size: 12px;
    }
    .el-checkbox__label{
      font-size: 12px;
    }
    .el-input--small .el-input__inner{
      width: 220px;
      font-size: 12px;
    }
    .sys-note-index{
      width: 640px;
    }
  }
}
.reference {
  color: #3e8bc6;
  cursor: pointer;
}
.signItem{
  // display: inline-block;
  // width: 100%;
  ::v-deep .signatureDiv{
    line-height: 18px;
    border: 1px solid #eeeeee;
    padding: 10px;
    margin-top: 4px;
    overflow-x: auto;
    // width: 100%
    div,
    span,
    object,
    li,
    ul,
    img iframe,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    pre,
    a,
    em,
    img,
    strong,
    sub,
    sup,
    b,
    i,
    dl,
    dt,
    dd,
    ol,
    ul,
    li,
    fieldset,
    form,
    label,
    legend,
    table,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td,
    article,
    aside,
    canvas,
    details,
    embed,
    figure,
    figcaption,
    footer,
    header,
    menu,
    nav,
    output,
    ruby,
    section,
    abstractDesc,
    time,
    mark,
    audio,
    video,
    input,
    textarea,
    select,
    button,
    meter,
    progress {
      margin: revert;
    }
    a{
      color: rgb(0, 0, 238) !important;
    }
    img {
      // width: 100%;
    }
  }
}
.definiteTimediv{
  margin-bottom: 7px;
  font-size: 12px
}
.definiteTime{
  border: 1px solid #FF7F2A;
  border-radius: 2px;
  padding: 4px 8px 4px 4px;
  /* border: 1px saddlebrown; */
  font-size: 12px;
  color: #FF7F2A;
  font-family: SourceHanSansCN-Regular;
  margin-right: 6px;
}
.scheduleSendTimezoneStr{
  border: 1px solid #CFD5DF;
  border-radius: 2px;
  padding: 0px;
  padding: 7px 16px;
  font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  color: #16181A;
  .label{
    font-family: SourceHanSansCN-Regular;
    font-size: 12px;
    color: #4F5D78;
    margin-right: 12px;
  }
}
.icon-icon-dingshi{
  font-size: 12px;
  margin-right: 4px;
}
</style>
<style>
.el-popover.my-popover-term {
  padding-top: 0;
  height: 300px !important;
  overflow: auto !important;
  font-size: 12px !important;
}
</style>